import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { goodsService } from 'shared/src/api';

export const useGoodsLikeRecommend = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.goodsLikeRecommend(goodsSno, 'like'),
    queryFn: () => goodsService.getGoodsLikeRecommend(goodsSno),
  });
};
